import { Hidden } from '@material-ui/core';
import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { usePersonManagementReset } from '../../../pages/arc/hooks/usePersonManagementReset';
import { TcsmStates } from '../../../root/tcsm-model';
import { removeForbiddenFeature } from '../../ducks/authenticated-slice';
import { TcsmSiteSettingsProps } from '../../models/epi-model';
import { TcsmFeatures } from '../../models/features-model';
import { TcsmContentPage } from '../../models/tcsm-page-models';
import { BlockFactory } from '../block-factory';
import { GuidedProcessSupportBlock } from '../guided-process-support-block';
import { ContentSpacer } from '../layout/generic-content-spacer';
import { MainContent } from '../layout/main-content-container';
import { PageContainer } from '../layout/page-container';
import { PageHeader } from '../layout/page-header';
import { SideBarContent } from '../layout/sidebar-content';
import { WysiwygWithReactLink } from '../wysiwyg-with-react-link';
import { Breadcrumbs } from '../breadcrumbs';
import { ButtonWrapper } from '../layout/button-wrapper';
import { buttonStyles } from '../../constants/theme/styles/components/buttonstyles';

interface Props {
	pageData: TcsmContentPage,
	hideBreadCrumbs?: boolean,
}

export function TcsmContentPageView(props: Props) {
	const siteSettings = useSelector<TcsmStates, TcsmSiteSettingsProps>(state => state?.epiProps?.siteSettingsState?.siteSettings);
	const { pageData, hideBreadCrumbs } = props;
	const dispatch = useDispatch();
	const buttonClasses = buttonStyles();

	useEffect(() => {
		dispatch(removeForbiddenFeature(TcsmFeatures.InstitutionAdministratorSearch));
	}, []);

	usePersonManagementReset();

	return (
		<>
			{
				!hideBreadCrumbs && <Breadcrumbs routeBreadcrumbs={siteSettings.routeBreadcrumbs} />
			}
			<PageContainer>
				<MainContent>
					<PageHeader
						headerText={pageData?.pageTitle}
					/>
					<Hidden mdUp>
						<SideBarContent>
							<GuidedProcessSupportBlock title={pageData?.gpsTitle} contents={pageData?.gps} />
						</SideBarContent>
					</Hidden>
					<ContentSpacer>
						<WysiwygWithReactLink content={pageData?.mainContent} />
					</ContentSpacer>
					{
						pageData?.contentArea?.map((a, idx) => <BlockFactory key={idx} blockData={a} />)
					}
					{
						pageData?.footerLink &&
						<ButtonWrapper flexEnd>
								<Link className={buttonClasses.primaryButton} to={pageData?.footerLink}>{pageData?.footerLinkTitle}</Link>
						</ButtonWrapper>
					}
				</MainContent>
				<Hidden smDown>
					<SideBarContent>
						<GuidedProcessSupportBlock title={pageData?.gpsTitle} contents={pageData?.gps} />
					</SideBarContent>
				</Hidden>
			</PageContainer>
		</>
	);
}

export default TcsmContentPageView;


TcsmContentPageView.defaultProps = {
	hideBreadCrumbs: false,
};